module.exports = __webpack_public_path__ + "static/media/Crustle_gaussian2.e2d80145.png";